<template>
  <div class="customer-manage">
    <div class="app-panel blank-v blank-h">
      <el-radio-group v-model="search.type" class="app-radio-group">
        <el-radio-button v-for="(value, index) in typeOptions" :key="index" :label="value.value">{{value.text}}（{{value.count}}）</el-radio-button>
      </el-radio-group>
    </div>
    <div class="app-panel blank-h blank-v">
      <div class="app-search-controls">
        <div class="wrap">
          <p>首次到访时间</p>
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodOne" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </div>
        <div class="wrap">
          <p>末期到访时间</p>
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodTwo" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </div>
      </div>
      <div class="app-control app-table-control">
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
      <el-table :data="datas" v-loading="loading">
        <el-table-column label="照片">
          <template slot-scope="{row}">
            <el-image :src="row.face_data[0].attachment_data.attachment_access_url" :preview-src-list="[row.face_data[0].attachment_data.attachment_access_url]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="attr_data.project_customer_attr_other"></el-table-column>
        <el-table-column label="首次到访时间" prop="first_recognition_at"></el-table-column>
        <el-table-column label="近期到访时间" prop="last_recognition_at"></el-table-column>
        <el-table-column label="到访次数" prop="attr_data.project_customer_day_visit_count"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="scan(row.attr_data.project_customer_id)">查看</el-button>
            <el-button type="text" @click="edit(row.attr_data.project_customer_id)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    </div>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center size="80%" append-to-body>
      <customer-information :id="dialog.id" v-if="dialog.show"></customer-information>
    </el-drawer>
  </div>
</template>

<script>
  import CustomerService from '@/io/customer.js';
  import CustomerInformation from '@/views/CustomerInformation.vue';

  export default {
    name: 'CustomerManage',
    data() {
      return {
        loading: false,
        search: {
          type: '',
          periodOne: [],
          periodTwo: []
        },
        typeOptions: [],
        ageOptions: [],
        sexOptions: [],
        datas: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        dialog: {
          title: '客户详情',
          show: false,
          id: null
        }
      }
    },
    components: {
      CustomerInformation,
    },
    watch: {
      'search.type'(newValue, oldValue) {
        this.searchParams();
      }
    },
    mounted () {
      this.initType().then(res => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initType() {
        return CustomerService.paramInfo().then(res => {
          this.ageOptions = res.data.age.map(val => {
            return {
              text: val.text,
              value: `${val.range.min}-${val.range.max}`
            };
          });
          this.sexOptions = res.data.gender;
          let count = 0;
          res.data.customer_type.forEach(val => {
            count += val.count;
          });
          this.typeOptions = [
            {
              text: '全部客户',
              count,
              value: ''
            }
          ].concat(res.data.customer_type);
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        CustomerService.listPage(
          this.search.type,
          this.search.periodOne ? this.search.periodOne[0] : '',
          this.search.periodOne ? this.search.periodOne[1] : '',
          this.search.periodTwo ? this.search.periodTwo[0] : '',
          this.search.periodTwo ? this.search.periodTwo[1] : '',
          this.page.currentPage
        ).then(res => {
          let datas = [];
          res.data.data.forEach(val => {
            if (val.face_data.length) {
              datas.push(val);
            }
          });
          this.datas = datas;
          this.page.pageSize = res.data.per_page;
          this.page.total = res.data.total;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      scan(id) {
        this.dialog.show = true;
        this.dialog.id = id * 1;
      },
      edit(id) {
        this.$router.push({
          path: `/customer_manage/edit/${id}`
        });
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search = {
          type: '',
          age: null,
          sex: null,
          periodOne: [],
          periodTow: []
        };
        this.searchParams();
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .customer-manage {
    .app-panel {
      &:nth-of-type(2) {
        &.blank-v {
          padding-bottom: 0;
        }
      }
    }
  }
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>